// REACT 
import React, {Component} from 'react'

// TRANSLATE
import { translate } from 'react-i18next';

// COMPONENTS
import BannerTop from '../../components/bannertop/bannertop.component';
import Notes from '../../components/notes/notes.component';

// CANTAINERS
import Box from '../../containers/Box/box.container';
import List from '../../containers/List/list';

class Recipes extends Component {
    state = {
        view: true,
        order: parseInt(localStorage.getItem('neworder'), 0),
        open: false
    };

    

    UNSAFE_componentWillUpdate(){
        const requestLang = window.location.pathname.split('/');
        const size = requestLang.length - 1;

        if (requestLang[size] === ""){
            let url = '/'+this.props.i18n.language+'/'+this.props.t('receitas');
            this.props.history.replace(url, true)
        }

        let lang = requestLang[1];

        if (lang !== this.props.i18n.language) {
            let url = '/'+this.props.i18n.language+'/'+this.props.t('receitas');
            this.props.history.replace(url, true)
        }
    }

    setOrder(value) {
        this.setState({
            order: value
        })
        localStorage.setItem('neworder', value);
    }

    setView(value) {
        this.setState({
            view: value
        })
    }

    openModal = () => {
        this.setState({
            open: !this.state.open
        })
    }


    closeModal = () => {
        this.setState({
            open: false
        })
    }

    render() {
        const {
            t,
            i18n,
            match
        } = this.props;

        const {
            view,
            order,
            open
        } = this.state;

        return(
            <div id="start">
                <BannerTop t={t} type={5} title={t('HeaderReceitas')}/>
                <Box 
                    t={t}
                    to="recipes"
                    setView={(value) => this.setView(value)}
                    view={view}
                    setOrder={(value) => this.setOrder(value)}
                    order={order}
                    i18n={i18n}
                />
                <List
                    t={t}
                    i18n={i18n}
                    match={match.url}

                    to="recipes"
                    order={order}

                    perPage={9}
                    page={1}
                    filter={true}

                    activeCategory={true}
                    activeMember={false}
                    activeCountry={false}
                    activeQualification={false}
                    activeArea={true}
                    activeTime={true}
                    pagination={true}

                    open={open}
                    close={this.closeModal}
                />
                <Notes t={t} type="recipe"/>        
            </div>
        )
    }
}

export default translate('translations')(Recipes);




// WEBPACK FOOTER //
// ./src/pages/recipes/recipes.page.js